// extracted by mini-css-extract-plugin
export default {"logo_wrap":"LogoMobile_logo_wrap__Q23E-"};